<template>
  <div class="card border-radius-none">
    <div class="commandes__produits">
      <div class="commandes__ligne commandes__ligne--border-width">
        <div class="commandes__ligne-selecteurs" style='--margin: 21px 0 0 0;'>
          <b-icon class="drag" icon="drag"
                  :class="{
                    'pointer-no-drop' : disabledDraggable,
                    'draggable-handle' : !disabledDraggable
                  }">
          </b-icon>
          <b-checkbox :value="ligneCommande.selected"
            :disabled = "disabled"
                      @input="selectLigneOfRegroupement(ligneCommande.referencePersonnalise)">
          </b-checkbox>
        </div>

        <div class="commandes__ligne-libelle">
          <b-field custom-class="is-size-7 is-marginless has-text-link"
                   :label="$t('detail.article.libelle')">
            <b-input v-model="ligneCommande.libelle" type="textarea"
              :rows="nbLignesLibelle"
              :disabled = "disabled"
                     :maxlength="SIZE_LIBELLE_REGROUPEMENT_PERSO">
            </b-input>
          </b-field>
        </div>

        <div class='commandes__fin-ligne'>

          <div class="has-text-weight-semibold">
              <span v-if="ligneCommande.totalHt" class="is-fullwidth ellipsis">
                {{ligneCommande.totalHt | formatDevise}}
              </span>
            <span v-else> {{ 0.00 | formatDevise }} </span>
          </div>

          <div>
            <a @click="toggleDetail()" class="iconArrowMenu"
                :class="{'iconRecouvrementArrowMenuOpen': openDetail}">
              <b-icon
                icon="arrow-right-drop-circle"
                type="is-default"
              >
              </b-icon>
            </a>
          </div>

          <b-dropdown position="is-bottom-left" aria-role="list"
            :disabled = "disabled">
            <a slot="trigger">
              <b-icon
                custom-class="has-text-icon-more"
                icon="dots-vertical">
              </b-icon>
            </a>
            <b-dropdown-item aria-role="listitem"
              @click="getLigneDuRegroupement(ligneCommande.referencePersonnalise)">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">
                    {{ $t('ligneRegroupementPersonnalisee.infoRegroupement')}}
                  </p>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
                             :disabled="!canDelete"
                             v-if="!isCommandeAchatBailleur"
                             @click="dissocierProduit()">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">
                    {{ $t('ligneRegroupementPersonnalisee.dissociate')}}
                  </p>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
                             :disabled="!canDelete"
                             @click="supprimerLigne()">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">{{ $t('detail.article.delete')}}</p>
                </div>
              </div>
            </b-dropdown-item>
          </b-dropdown>

        </div>
      </div>
      <br>
    </div>
    <qd-collapse :open="openDetail" animation="slide-fade">
      <div class="card-article-personnalise">
        <div :key="ligne.ordre"
                      v-for="ligne in lignesCommande">
          <app-articles
            v-if="ligne.type === 'Normal'
              && ligne.referencePersonnalise === ligneCommande.referencePersonnalise"
            class="has-background-table-second-color"
            :lignesCommande="lignesCommande"
            :ligneCommande="ligne"
            :devisCommande="devisCommande"
            :error="error"
            :disabled = "disabled"
            :isCreditNote="isCreditNote"
            :modulePresseActive="modulePresseActive"
            :filtrerProduitParSociete="filtrerProduitParSociete"
            :regimesTva="regimesTva"
            :canDelete="canDelete"
            @reloadTotalHt="calcul()"
            @modificationLigneCommande="modificationLigneCommande"/>
          <app-ligne-regroupement
            v-if="ligne.type === 'Regroupement'
              && ligne.referencePersonnalise === ligneCommande.referencePersonnalise"
            :devisCommande="devisCommande"
            class="has-background-table-second-color"
            :lignesCommande="lignesCommande"
            :ligneCommande="ligne"
            :disabled = "disabled"
            :canDelete="canDelete"
            :isCreditNote="isCreditNote"
            :modulePresseActive="modulePresseActive"
            :periodeTotalCalculTlpeAuto="periodeTotalCalculTlpeAuto"
            :filtrerProduitParSociete="filtrerProduitParSociete"
            :activationYield="activationYield"
            :regimesTva="regimesTva"
            racineTraduction="ajoutDevis"
            @reloadTotalHt="calcul()"
            @modificationLigneCommande="modificationLigneCommande"
            :error="error"/>
        </div>
        <div class="card-article-bord-personnalisee">&nbsp;
        </div>
      </div>
    </qd-collapse>
    <b-modal v-model="popUpInformationRegroupement" has-modal-card class="modal">
      <app-information-regroupement-personnalise :lignesCommande="ligneDuRegroupement"/>
    </b-modal>
  </div>
</template>

<script>
import gestionType from '@/services/general/gestionType';
import Articles from '@/components/devisCommandes/editionDevisCommande/m_ligneCommandeBasique';
import LigneRegroupement from '@/components/devisCommandes/editionDevisCommande/m_ligneProduit';
import deleteLignesEcheanciersInutiles from '@/services/commande/echeancierFacturation/deleteLignesEcheanciersInutiles';
import { SIZE_LIBELLE_REGROUPEMENT_PERSO } from '@/configuration/dcf/dcfConf';
import { MODULE_BAIL, TYPE_COMMANDE } from '@/configuration/devisConf';
import informationRegroupementPersonnalise from './informationRegroupementPersonnalise';

export default {
  name: 'DevisCommandesEditRegroupementPersonnalise',
  props: {
    lignesCommande: Array,
    ligneCommande: Object,
    error: Boolean,
    devisCommande: Object,
    isCreditNote: Boolean,
    sens: String,
    disabledDraggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDelete: {
      type: Boolean,
      required: false,
      default: true,
    },
    modulePresseActive: {
      type: Boolean,
      required: true,
    },
    periodeTotalCalculTlpeAuto: {
      type: Boolean,
      required: true,
    },
    filtrerProduitParSociete: {
      type: Boolean,
      required: true,
    },
    activationYield: {
      type: Boolean,
      required: true,
    },
    regimesTva: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      popUpInformationRegroupement: false,
      ligneDuRegroupement: [],
      openDetail: true,
      SIZE_LIBELLE_REGROUPEMENT_PERSO: SIZE_LIBELLE_REGROUPEMENT_PERSO,
    };
  },
  components: {
    appInformationRegroupementPersonnalise: informationRegroupementPersonnalise,
    appArticles: Articles,
    appLigneRegroupement: LigneRegroupement,
  },
  computed: {
    typeLibelle() {
      return gestionType(this.ligneCommande.libelle, this.error);
    },
    nbLignesLibelle() {
      if (this.ligneCommande.libelle) {
        return this.ligneCommande.libelle.split('\n').length;
      }
      return 1;
    },
    isCommandeAchatBailleur() {
      return this.devisCommande.type === TYPE_COMMANDE
        && this.devisCommande.module === MODULE_BAIL;
    },
  },
  methods: {
    toggleDetail(value) {
      this.openDetail = value ?? !this.openDetail;
    },
    selectLigneOfRegroupement(id) {
      this.ligneCommande.selected = !this.ligneCommande.selected;
      this.lignesCommande.forEach((ligne) => {
        if (ligne.referencePersonnalise === id) {
          ligne.selected = this.ligneCommande.selected;
        }
      });
    },
    getLigneDuRegroupement(idPersonalise) {
      this.popUpInformationRegroupement = true;
      this.ligneDuRegroupement = [];
      this.lignesCommande.forEach((el) => {
        if (el.referencePersonnalise === idPersonalise) {
          this.ligneDuRegroupement.push(el);
        }
      });
    },
    dissocierProduit() {
      this.$emit('dissocierPersonnalise', this.ligneCommande.ordre);
    },
    calcul() {
      this.$emit('reloadTotalHt');
    },
    modificationLigneCommande(nouvelleLigneCommande, ordre, type) {
      this.$emit('modificationLigneCommande', nouvelleLigneCommande, ordre, type);
    },
    supprimerLigne() {
      const numberOfLigneToDelete = this.lignesCommande.filter((ligne) => {
        return ligne.referencePersonnalise === this.ligneCommande.referencePersonnalise;
      }).length;
      this.lignesCommande.splice(
        this.lignesCommande.indexOf(this.ligneCommande), numberOfLigneToDelete,
      );
      deleteLignesEcheanciersInutiles(this.devisCommande);
      this.$emit('reloadTotalHt');
    },
  },
  inject: ['allOpen'],
  mounted() {
    this.openDetail = this.allOpen();
  },
};
</script>
